import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class MachineService {
    constructor(http) {
        this.http = http;
        this.singular = 'machine';
        this.plural = 'machines';
        this.editor = PLATFORM.moduleName('pages/standard-setup/machines/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`machines/filter/${loadOptions}`);
        return await response.json();
    }

    async create(machine) {
        await this.http.fetch('machines', { method: 'POST', body: json(machine) });
    }

    async update(machine) {
        await this.http.fetch(`machines/${machine.id}`, { method: 'PUT', body: json(machine) });
    }

    async delete(id) {
        await this.http.fetch(`machines/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`machines/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`machines/top-three/${query}`);
        return await response.json();
    }
}